// extracted by mini-css-extract-plugin
export default {"searchOffer":"oTxJjcMJWT2OklHYBxRj"};